import { zodResolver } from '@hookform/resolvers/zod';
import { register } from 'mixpanel-browser';
import React, { FC, useContext } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import TextInput from '@ui/forms/TextInput';

import BackAndNextNav from '@ui/molecules/BackAndNextNav';
import SpacedGridItem from '@ui/molecules/SpacedGridItem';

import FlowContext from '@providers/FlowContextProvider';

import { IFlowStepComponentProps } from '@folx-types/flow-steps';

import { dataConstants, schema } from './DlInputStep.data';

export interface IDlInputStepPageContent {
	dlInputLabel: string;
}

interface IDlInputStepProps extends IFlowStepComponentProps {
	pageContent: IDlInputStepPageContent;
}

const DlInputStep: FC<IDlInputStepProps> = ({ pageContent, stepKey }) => {
	const { dlInputLabel } = pageContent;

	const { existingFormData, handleFormSubmission, handleNavBack } = useContext(FlowContext);

	type Schema = Partial<z.input<typeof schema>>;

	const form = useForm<Schema>({
		defaultValues: {
			...(existingFormData as unknown as Schema),
		},
		resolver: zodResolver(schema),
		mode: 'onChange',
	});
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = form;

	const onSubmit = (data: Record<string, unknown>) => {
		handleFormSubmission(data, stepKey);
	};

	return (
		<SpacedGridItem marginBottom="lgxl">
			<form onSubmit={handleSubmit(onSubmit)}>
				<TextInput
					label={dlInputLabel}
					error={!!errors[dataConstants.DLN]?.message}
					errorLabel={errors[dataConstants.DLN]?.message ?? ''}
					{...register(dataConstants.DLN, { required: true })}
				/>
				<BackAndNextNav
					marginTop="xxl"
					submitLabel="Next"
					backOnClick={() => handleNavBack(stepKey)}
				/>
			</form>
		</SpacedGridItem>
	);
};

export default DlInputStep;
